import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import LoadingIndicator from "layout/components/Loading";
import Table from "components/table/Table";
import { AddButton, SmallScreenModel } from "components";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import { fetchPackages } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import HandleCreateDcddPlan from "./HandleCreateDcddPlan";
import { fetchDcddMembership } from "../store/action";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const DcddMembershipTable: React.FC<Props> = ({
  onDcddMembership,
  fetchDcddmembership,
  fetchPackages,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onDcddMembership();
  }, [onDcddMembership]);
  const { authUser, action, superAdmin } = useUser();
  const packageId = fetchPackages?.package?.id.toString();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_DCDD_MEMBERSHIP_PLAN));
  return (
    <div className="">
      <Table
        headers={["Membership Plan", "DCDD Membership Plan"]}
        data={fetchDcddmembership?.membership}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add DCDD plan"
                tooltip="Add new DCDD membership plan"
              />
            )}
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandleCreateDcddPlan closeModal={closeModal} packageId={packageId} />
        </div>
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchDcddmembership: state.dcddMembership?.dcddMembershipState,
    fetchPackages: state.dcddPackage?.dcddPackageState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onDcddMembership: () => dispatch(fetchDcddMembership()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DcddMembershipTable);
